module.exports = __webpack_public_path__ + "static/media/at.7fc4e220.svg";